import React, { useState, useEffect, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Title from '../../component/Title'
import API from '../../component/Axios'
import Snackbars from '../../component/Snackbars'
import BottomButtonGroup from '../../component/BottomButtonGroup'
import Spiner from '../../component/Spiner'
import ListEmptyState from '../../component/ListEmptyState'
import { Map, MapMarker, Polyline } from "react-kakao-maps-sdk"
import { getLocationState } from '../../utils/listPageState'

const DEFAULT_SEARCH_SELECT = {
    searchType: 0,
}

export default function AppRunning(props) {
    const history = useHistory()
    const location = useLocation()
    const locationState = getLocationState(location)
    const id = props.match.params.userRunId
    const type = locationState.type
    const searchText = locationState.searchText || ''
    const searchSelect = locationState.searchSelect || DEFAULT_SEARCH_SELECT
    const curPage = locationState.curPage || 1
    const listSearch = location.search || ''
    const [loading, setLoading] = useState(true)
    const [hasDetail, setHasDetail] = useState(false)
    const [params, setParams] = useState([])
    const [center, setCenter] = useState({ lat: 33.452344169439975, lng: 126.56878163224233 })
    const [start, setStart] = useState({ lat: 33.452344169439975, lng: 126.56878163224233 })
    const [finish, setFinish] = useState({ lat: 33.452344169439975, lng: 126.56878163224233 })
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [severitySnackbar, setSeveritySnackbar] = useState('info')
    const [messageSnackbar, setMessageSnackbar] = useState('')
    const [detailErrorMessage, setDetailErrorMessage] = useState('')

    const getData = useCallback(async () => {
        if (!id) {
            const errorMessage = '필수 파라미터가 없어 러닝 상세를 불러올 수 없습니다.'
            setParams([])
            setHasDetail(false)
            setDetailErrorMessage(errorMessage)
            setOpenSnackbar(true)
            setSeveritySnackbar('error')
            setMessageSnackbar(errorMessage)
            setLoading(false)
            return
        }

        setLoading(true)
        setHasDetail(false)
        setDetailErrorMessage('')

        try {
            const { data } = await API.post('/api/v1/admin/appRunning/getDetail', { type: type, userRunId: id })
            // console.log('data: ', data.data )
            if (data.code === 200) {
                const runningPath = data.data || []
                setParams(runningPath)
                if (runningPath.length > 0) {
                    setCenter(runningPath[0])
                    setStart(runningPath[0])
                    setFinish(runningPath[runningPath.length-1])
                    setHasDetail(true)
                    setDetailErrorMessage('')
                    return
                }

                setDetailErrorMessage('러닝 경로 정보를 찾을 수 없습니다.')
            } else if (data.code === 403) {
                history.push('/login')
                return
            } else {
                const errorMessage = data.message || '러닝 상세를 불러오지 못했습니다.'
                setParams([])
                setDetailErrorMessage(errorMessage)
                setOpenSnackbar(true)
                setSeveritySnackbar('error')
                setMessageSnackbar(errorMessage)
            }
        } catch (_error) {
            const errorMessage = '러닝 상세를 불러오지 못했습니다.'
            setParams([])
            setDetailErrorMessage(errorMessage)
            setOpenSnackbar(true)
            setSeveritySnackbar('error')
            setMessageSnackbar(errorMessage)
        } finally {
            setLoading(false)
        }
    }, [history, id, type])

    useEffect(() => {
        getData()
    }, [getData])

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    // 상세 조회 실패 시 목록 화면과 같은 오류 빈 상태 안내를 사용한다.
    const renderDetailErrorState = () => (
        <ListEmptyState
            variant="error"
            title="App 러닝 상세를 불러오지 못했습니다."
            description={detailErrorMessage || '목록으로 돌아가 다시 확인하세요.'}
            action={(
                <BottomButtonGroup variant="emptyStateAction" path="/appRunnings" search={listSearch} visible={false} searchText={searchText} searchSelect={searchSelect} curPage={curPage} backLabel="목록으로"/>
            )}
            sx={{ mt: 2 }}
        />
    )

    if (loading) {
        return (
            <Grid item xs={12}>
                <Spiner />
                {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
            </Grid>
        )
    }

    if (!hasDetail) {
        return (
            <Grid item xs={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Title>App 러닝 상세</Title>
                    {renderDetailErrorState()}
                    {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
                </Paper>
            </Grid>
        )
    }

    return (
        <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <Title>App 러닝 상세</Title>
                <Box component="form" encType="multipart/form-data" >
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Map center={center} style={{ width: "100%", height: "600px" }}>
                    <MapMarker position={start} title={'start'}>
                        {/* <div style={{ color: "#000" }}>start!</div> */}
                    </MapMarker>
                    <MapMarker position={finish} title={'finish'} >
                        {/* <div style={{ color: "#000" }}>start!</div> */}
                    </MapMarker>
                    <Polyline
                        path={params}
                        strokeWeight={5} // 선의 두께 입니다
                        strokeColor={"red"} // 선의 색깔입니다
                        strokeOpacity={0.7} // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
                        strokeStyle={"solid"} // 선의 스타일입니다
                    />
                </Map>
                </Grid>
                <BottomButtonGroup path="/appRunnings" search={listSearch} visible={false} searchText={searchText} searchSelect={searchSelect} curPage={curPage}/>
                </Box>
                {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
            </Paper>
        </Grid>
    )
}
